/**
 * Login
 */
export const SET_LOGIN_USER = 'SET_LOGIN_USER';
export const SET_LOGIN_FLAG = 'SET_LOGIN_FLAG';
export const SET_GYMS = 'SET_GYMS';
export const SET_GYM = 'SET_GYM';
export const SET_GYM_ATTRIBUTES = 'SET_GYM_ATTRIBUTES';
export const SET_TRAINERS = 'SET_TRAINERS';
export const SET_TRAINER = 'SET_TRAINER';
export const SET_TRAINER_ATTRIBUTES = 'SET_TRAINER_ATTRIBUTES';
export const SET_SOCIALMEDIA= 'SET_SOCIALMEDIA';
//  export const SET_SEARCH_TERM= 'SET_SEARCH_TERM';
// export const SET_SEARCH= 'SET_SEARCH';
// export const SET_CLASS = 'SET_CLASS';
export const SET_CLASS_COUNT = 'SET_CLASS_COUNT';
export const SET_CLASSES = 'SET_CLASSES';
export const SET_CLASS = 'SET_CLASS';
export const SET_ACCOUNTS = 'SET_ACCOUNTS';
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_ACCOUNT_COUNT = 'SET_ACCOUNT_COUNT';
export const SET_USER_INFO = 'SET_USER_INFO';
export const RESET_USER_INFO = 'RESET_USER_INFO';
export const RESET_GYMS = 'RESET_GYMS';
export const SET_CLASS_SEARCH= 'SET_CLASS_SEARCH';
export const SET_TRAINER_SEARCH= 'SET_TRAINER_SEARCH';

export const SET_NOTIFICATIONS_DATA =  'SET_NOTIFICATIONS_DATA';
export const SET_UNREAD_NOTIFICATION_COUNT =  'SET_UNREAD_NOTIFICATION_COUNT';

export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_DIRECTION = 'SET_DIRECTION';
export const SET_LOGIN_MODAL = 'SET_LOGIN_MODAL';

export const SET_CARDS = "SET_CARDS";
export const SET_COUNTRY = 'SET_COUNTRY';
export const SET_LOGINUSERTYPE = 'SET_LOGINUSERTYPE';
export const SET_COUNTRY_POPUP = 'SET_COUNTRY_POPUP';
export const SET_TERMS = 'SET_TERMS';
export const SET_PRIVACY_POLICY = 'SET_PRIVACY_POLICY';
export const SET_WODS = 'SET_WODS';
export const SET_RATING_MODAL = 'SET_RATING_MODAL';

